var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 170 65 C 170 34.624329 145.375671 10 115 10 C 84.624336 10 60 34.624329 60 65 C 60 95.375664 84.624336 120 115 120 C 145.375671 120 170 95.375664 170 65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-copy",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 40 155 C 40 146.715729 33.284271 140 25 140 C 16.715729 140 10 146.715729 10 155 C 10 163.284271 16.715729 170 25 170 C 33.284271 170 40 163.284271 40 155 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistant);
export default __webpack_public_path__ + "static/media/distant.6a52141b0759d82f81adf5fd07937f3d.svg";
export { ForwardRef as ReactComponent };